const VALUES = [
  {
    icon: "ri-shield-check-line",
    title: "Security First",
    desc: "Every application we build is designed with privacy and security as the cornerstone principle.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Clean Engineering",
    desc: "We craft elegant, maintainable code that stands the test of time and scales with your needs.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centered",
    desc: "Intuitive interfaces that delight users and make complex functionality feel effortless.",
  },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full py-32"
      style={{ background: "linear-gradient(180deg, #0a0a0a 0%, #0f0f0f 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-8">
        {/* Section label */}
        <div className="mb-4">
          <span className="text-[#00d4c8] text-xs font-bold tracking-[0.25em] uppercase">
            WHO WE ARE
          </span>
        </div>

        {/* Title */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-20">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white leading-tight max-w-xl">
            A Team Built for
            <br />
            <span className="text-[#00d4c8]">Innovation</span>
          </h2>
          <p className="text-[#7a7a7a] text-lg leading-relaxed max-w-lg">
            ALDEGO d.o.o. is a specialized team of iOS engineers, designers, and security researchers
            united by a passion for building products that genuinely improve people&apos;s digital lives.
            Based in Slovenia, we operate on a global scale.
          </p>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {VALUES.map((v) => (
            <div
              key={v.title}
              className="bg-[#141414] border border-white/5 rounded-2xl p-8 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#00d4c8]/10 mb-6">
                <i className={`${v.icon} text-[#00d4c8] text-2xl`} />
              </div>
              <h3 className="text-white text-xl font-bold mb-3">{v.title}</h3>
              <p className="text-[#7a7a7a] text-base leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
